var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoWithoutText(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 80,
    viewBox: "0 0 76 80",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.6121 29.8637H39.3203L75.1763 0.000976562L48.6121 29.8637Z",
    fill: "#F96302"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.94 29.8637H53.3281L75.1775 0.000976562L58.94 29.8637Z",
    fill: "#F96302"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1272 54.9688H33.5254L3.48828 0.000976562L42.1272 54.9688Z",
    fill: "#F96302"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5523 58.1323L39.4124 65.7539L35.2266 58.1323H43.5523Z",
    fill: "#F96302"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5891 52.5668L3.48828 0.000976562L39.3213 29.8637L46.5891 52.5668Z",
    fill: "#F96302"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9177 38.1094L52.9121 40.9271L48.9102 48.2946L44.1953 33.5596H56.9369L64.9177 38.1094Z",
    fill: "#F96302"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0339 31.3142L0.820312 22.4224H10.342L15.0339 31.3142Z",
    fill: "#F96302"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4007 68.1052L25.0391 79.9995L32.7668 61.6846L36.4007 68.1052Z",
    fill: "#F96302"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWithoutText);
export default __webpack_public_path__ + "static/media/LogoWithoutText.4c81411b647bb226363fdb4c321ffec7.svg";
export { ForwardRef as ReactComponent };